module.exports = __webpack_public_path__ + "static/content_types-7b12e6f6893d0ebc1d2aae31153e9468.gif";